import actions from './moduleCompoundedOrderActions.js';

export default {
  namespaced: true,
  actions: actions,
};
